<template>
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
    <div
      v-for="item in benefitItems"
      :key="item.key"
      class="flex gap-4"
    >
      <TImage
        :src="item.imgSrc"
        alt=""
        height="80"
        width="80"
        class="size-20"
      />
      <div>
        <div class="font-bold">
          {{ item.title }}
        </div>
        <div class="text-sm text-gray-500">
          {{ item.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

const { getStaticImage } = useImage()
const benefitItems = computed(() => [
  {
    key: 'support',
    imgSrc: getStaticImage({
      path: '/web/images/custom-icons/real-support.svg',
    }),
    title: t('support.title'),
    description: t('support.description'),
  },
  {
    key: 'protection',
    imgSrc: getStaticImage({
      path: '/web/images/custom-icons/protection-insurance.svg',
    }),
    title: t('protection.title'),
    description: t('protection.description'),
  },
  {
    key: 'delivery',
    imgSrc: getStaticImage({
      path: '/web/images/custom-icons/delivery-pickup.svg',
    }),
    title: t('delivery.title'),
    description: t('delivery.description'),
  },
])
</script>

<i18n lang="json">
  {
    "en": {
      "support": {
        "title": "Real Support, Real People",
        "description": "Top rated customer support available in real time before, during, and after your trip"
      },
      "protection": {
        "title": "Built In Protection",
        "description": "Every rental includes insurance coverage and 24/7 roadside assistance for total peace of mind"
      },
      "delivery": {
        "title": "Pickup or Delivery Options",
        "description": "Choose verified RVs you can pick up locally or have delivered directly to your campsite"
      }
    },
    "fr": {
      "support": {
        "title": "Support réel, des gens réels",
        "description": "Support client bilingue et disponible en temps réel avant, pendant et après votre voyage"
      },
      "protection": {
        "title": "Protection incluse",
        "description": "Chaque location inclut une assurance et une assistance routière 24/7 pour vous aider à vous sentir en sécurité"
      },
      "delivery": {
        "title": "Options de ramassage ou de livraison",
        "description": "Choisissez des VRs vérifiés que vous pouvez ramasser localement ou qui vous sont livrés directement à votre site de camping"
      }
    }
  }
</i18n>
